import axios from "axios";
import React, { Component, ComponentProps } from 'react';
import { AuthStore } from './auth.store';

export class RootStore {
  constructor(public auth: AuthStore) { }
}



export const StoreContext = React.createContext<RootStore>({} as RootStore);
export const StoreProvider: React.FC<{ store: RootStore }> = ({ children, store }) => {
  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};

/* Hook to use store in any functional component */
export const useStore = () => React.useContext(StoreContext);

/* HOC to inject store to any functional or class component */
export const withStore = (component: Component) => (props: ComponentProps<any>) => {
  return <Component {...props} store={useStore()} />;
};



export const createInitalStore = () => {
  const authStore = new AuthStore();
  // TODO Check jwt from localstorage
  // TODO Implement axios interseptor
  // https://blog.bitsrc.io/setting-up-axios-interceptors-for-all-http-calls-in-an-application-71bc2c636e4e

  authStore.loadSessionFromLocalStorage()

  setInterval(() => {
    console.log('Refreshing JWT')
    if (authStore.jwt && authStore.refreshToken) {
      axios.post<{ access: string }>('/api/auth/refresh/', { access: authStore.jwt, refresh: authStore.refreshToken }).then(
        resp => authStore.refreshJwt(resp.data.access),
        () => authStore.logout()
      )
    }
  }, 5 * 60 * 1000)

  axios.interceptors.request.use(
    req => {
      if (req.url && req.url?.startsWith(process.env.REACT_APP_API_ROOT as string) && req.baseURL?.startsWith(process.env.REACT_APP_API_ROOT as string)) {
        console.log(req.baseURL, process.env.REACT_APP_API_ROOT, "********************************");

        try {
          const session = JSON.parse(localStorage.getItem('session') as string)
          if (session) {
            const headerName = process.env.REACT_APP_AUTHORIZATION_CUSTOM_HEADER || 'Authorization'
            req.headers[headerName] = `Bearer ${session.jwt}`
          }
        }
        finally {
          return req
        }
      }
      return req
    },
    error => {
      return Promise.reject(error)
    }
  );

  axios.interceptors.response.use(undefined,
    error => {
      if (error.response.status === 401) {
        authStore.logout()
      }
      return Promise.reject(error)
    }
  )

  return new RootStore(authStore)
}
